/**
 * super simple carousel
 * animation between panes happens with css transitions
 */
function Carousel(element, options = {}) {
  var self = this;
  element = $(element);
  console.log(element);

  var container = $(">ul", element);
  var panes = $(">ul>li", element);

  var pane_width = 0;
  var pane_count = panes.length;

  var current_pane = 0;

  this.paneChanged = options.pane_changed || function() {};
  var rowCount = 1;
  var collIdx;
  var asrtIdx;
  var itemIdx;
  var groupedColorIdx;
  var colorIdx;

  /**
   * initial
   */
  this.init = function(
    rowCnt,
    colorIdx1,
    groupedColorIdx1,
    itemIdx1,
    collIdx1,
    asrtIdx1
  ) {
    setPaneDimensions();
    rowCount = rowCnt;
    colorIdx = colorIdx1;
    groupedColorIdx = groupedColorIdx1;
    itemIdx = itemIdx1;
    collIdx = collIdx1;
    asrtIdx = asrtIdx1;

    $(window).on("load resize orientationchange", function() {
      setPaneDimensions();
      //updateOffset();
    });
  };

  /**
   * set the pane dimensions and scale the container
   */
  function setPaneDimensions() {
    pane_width = element.width();
    panes.each(function() {
      $(this).width(pane_width);
    });
    container.width(pane_width * pane_count);
  }

  /**
   * show pane by index
   * @param   {Number}    index
   */
  this.showPane = function(index, animate = true, color, swipe = "") {
    // between the bounds
    index = Math.max(0, Math.min(index, pane_count - 1));
    current_pane = index;
    var offset = -((100 / pane_count) * current_pane);
    if (index > pane_count) {
      return setContainerOffset(offset, animate);
    }
    setContainerOffset(offset, animate);

    this.paneChanged(
      rowCount,
      index,
      groupedColorIdx,
      itemIdx,
      collIdx,
      asrtIdx,
      swipe
    );
  };

  function setContainerOffset(percent, animate) {
    container.removeClass("animate");

    if (animate) {
      container.addClass("animate");
    }

    if (Modernizr.csstransforms3d) {
      container.css(
        "transform",
        "translate3d(" + percent + "%,0,0) scale3d(1,1,1)"
      );
    } else if (Modernizr.csstransforms) {
      container.css("transform", "translate(" + percent + "%,0)");
    } else {
      var px = ((pane_width * pane_count) / 100) * percent;
      container.css("left", px + "px");
    }
  }

  this.next = function() {
    return this.showPane(current_pane + 1, true, null, "swipeNext");
  };
  this.prev = function() {
    return this.showPane(current_pane - 1, true, null, "swipePrev");
  };

  function handleHammer(ev) {
    // disable browser scrolling
    ev.gesture.preventDefault();

    switch (ev.type) {
      case "dragright":
      case "dragleft":
        // stick to the finger
        var pane_offset = -(100 / pane_count) * current_pane;
        var drag_offset = ((100 / pane_width) * ev.gesture.deltaX) / pane_count;

        // slow down at the first and last pane
        if (
          (current_pane == 0 &&
            ev.gesture.direction == Hammer.DIRECTION_RIGHT) ||
          (current_pane == pane_count - 1 &&
            ev.gesture.direction == Hammer.DIRECTION_LEFT)
        ) {
          drag_offset *= 0.4;
        }

        setContainerOffset(drag_offset + pane_offset);
        break;

      case "swipeleft":
        self.next();
        ev.gesture.stopDetect();
        break;

      case "swiperight":
        self.prev();
        ev.gesture.stopDetect();
        break;

      case "release":
        // more then 50% moved, navigate
        if (Math.abs(ev.gesture.deltaX) > pane_width / 2) {
          if (ev.gesture.direction == "right") {
            self.prev();
          } else {
            self.next();
          }
        } else {
          self.showPane(current_pane, true);
        }
        break;
    }
  }

  if ("ontouchstart" in document.documentElement) {
    element
      .hammer({ drag_lock_to_axis: true })
      .on("release dragleft dragright swipeleft swiperight", handleHammer);
  }
}
// var carousel = new Carousel("#carousel");
// carousel.init();



// WEBPACK FOOTER //
// src/assets/js/carousel.js